// extracted by mini-css-extract-plugin
export default {"actionButton":"CouncilImportFileStatus__actionButton___EK0y1","detailItem":"CouncilImportFileStatus__detailItem___RkVz9"};